import { myLQATierStateValues } from '../../domain/my-lqa/product';
import { myLQATierVariantCreateSchema } from './tier-variant';
import { z } from 'zod';

export const myLQATierCreateSchema = z.object({
	name: z.string().nonempty('Name is required').min(1),
	plan: z.string().uuid('Plan is required'),
	variant: myLQATierVariantCreateSchema.omit({ tierId: true }),
});

export const myLQATierUpdateSchema = myLQATierCreateSchema
	.partial()
	.omit({ variant: true })
	.merge(
		z.object({
			position: z.number().optional(),
			state: z.enum(myLQATierStateValues).optional(),
		})
	);
